import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

// Tikis.
import { Api } from '../common/constants/api';
import { ServerResponse } from '../models/RES/serverResponse';

@Injectable({
    providedIn: 'root'
})
export class CountriesService {
  constructor(
    private _http: HttpClient
  ) {}

  url: string = Api.Countries;

  public GetAllCountries(): Observable<ServerResponse> {
    return this._http.get<ServerResponse>(`${this.url}/GetAllCountries`);
  }
}